/**
 * overviewView.ts — pure view logic for the landing dashboard (§11 O-1).
 * Kept component-free so vitest pins the two honesty fixes (the
 * dashboardView.ts pattern).
 */
import { stageDot } from '../../../theme/tokens'
import type { DealStage } from '../types'

// The chart's fixed frame: the four OPEN stages, always in pipeline order.
const OPEN_FRAME: readonly DealStage[] = ['New Lead', 'Qualified', 'Proposal Sent', 'Negotiation']

export interface OpenStageSlice {
  stage: DealStage
  value: number // integer pence
  fill: string
}

/**
 * The "Pipeline by stage" chart data (§11.C.2 — both honesty fixes):
 *
 * 1. FIXED OPEN FRAME, zero-filled: dealsByStage is the /stats GROUP BY over
 *    ALL stages with no zero-fill — closed stages appear and empty open
 *    stages vanish. This transform keeps ONLY the four open stages, always
 *    all four, so the card's "open deals" subtitle is true and a stage at
 *    zero still renders.
 * 2. STAGE-KEYED FILL: color comes from the stageDot map BY STAGE, never by
 *    array position — the CLAUDE.md chart-fill rule (binding by index of the
 *    existing-stages array reshuffles colors as data populates).
 */
export function openStageValueFrame(dealsByStage: { stage: string; value: number }[]): OpenStageSlice[] {
  return OPEN_FRAME.map((stage) => ({
    stage,
    value: dealsByStage.find((s) => s.stage === stage)?.value ?? 0,
    fill: stageDot[stage],
  }))
}
